import { IonItem, IonLabel } from "@ionic/react";
import styles from "./Chapter.module.scss";

export const Chapter = ({ chapter, unit, image, onClick }) => {
  return (
    <IonItem lines="full" className={styles.chapterItem} onClick={onClick}>
      <img alt="chapter" src={image} className={styles.chapterImage} />
      <IonLabel className="ion-text-wrap ion-margin-start">
        <h3>{chapter.text}</h3>
        <p>{unit.text}</p>
      </IonLabel>
    </IonItem>
  );
};
